<template>
	<div class="watch-readings-details-widget widget-alert-parameters">
		<div class="header">
			<h2>{{ title }}</h2>
			<button @click="openModal({ action: 'add', reading_type_id: type_id })" class="btn btn-primary btn-small btn-round">+</button>
		</div>
		<div class="body">
			<spinner v-if="parameters.loading || zones.loading" class="spinner"/>
			<div v-if="(!parameters.loading && !zones.loading) && (parameters.data.length || zones.data.length)" class="widget-table">
				<div class="widget-table-header" v-if="isBiometric">
					<div></div>
					<div>{{ $t('labels.general.name') }}</div>
					<div>{{ $t('labels.general.min') }}</div>
					<div>{{ $t('labels.general.max') }}</div>
					<div></div>
				</div>
				<div class="widget-table-header" v-if="isGeofencing">
					<div></div>
					<div>{{ $t('labels.general.name') }}</div>
					<div></div>
					<div></div>
					<div></div>
				</div>
				<div class="widget-table-body">
					<alert-parameters-row v-if="isBiometric"
						v-for="(item, index) in parameters.data"
						v-model="parameters.data[index]"
						:key="item.id"
						:deleteParameter="deleteParameter"
						:loading="loading.delete.has(item.id)"
						:user_uid="user_uid"
						:watch_id="watch_id"
						:type_id="type_id"
						:units="units"
						@edit="openModal({ action: 'edit', id: item.id, reading_type_id: type_id })"
						class="widget-table-row"/>
					<alert-parameters-zone v-if="isGeofencing"
						v-for="(item, index) in zones.data"
						v-model="zones.data[index]"
						:key="item.id"
						:deleteZone="deleteZone"
						:loading="loading.delete.has(item.id)"
						:user_uid="user_uid"
						:watch_id="watch_id"
						:type_id="type_id"
						class="widget-table-row zone"
						@edit="openModal({ action: 'edit', id: item.id, reading_type_id: type_id })"
						@click.native="onZoneClick(item)"/>
				</div>
			</div>
			<div v-if="(!parameters.loading && !parameters.data.length) && (!zones.loading && !zones.data.length)" class="no-results">{{ emptyMessage }}</div>
		</div>
		<modal-box-map-zone v-if="isGeofencing"/>
		<parameters-form v-if="modalBox.open && isBiometric" @close="closeModal" :params="modalBox.params" :user_uid="user_uid" :watch_id="watch_id"/>
		<zone-form v-if="modalBox.open && isGeofencing" @close="closeModal" :params="modalBox.params" :user_uid="user_uid" :watch_id="watch_id"/>
	</div>
</template>

<script>
import Readings from '@/utils/readings'
import AlertParametersRow from './rows/ReadingsWidgetAlertParametersRow'
import AlertParametersZone from './rows/ReadingsWidgetAlertParametersZone'
import ModalBoxMapZone from './modal/ModalBoxMapZone'
import ParametersForm from '../../biometric/ParametersForm'
import ZoneForm from '../../geofencing/ZoneForm'
export default {
	components: {
		AlertParametersRow,
		AlertParametersZone,
		ModalBoxMapZone,
		ParametersForm,
		ZoneForm
	},
	props: [
		'user_uid',
		'watch_id',
		'type_id'
	],
	data () {
		return {
			name: 'watch biometric parameters',
			loading: {
				parameters: false,
				delete: new Set()
			},
			parameters: {
				loading: false,
				error: null,
				data: []
			},
			zones: {
				loading: false,
				error: null,
				data: []
			},
			modalBox: {
				open: false,
				params: {}
			}
		}
	},
	computed: {
		units () {
			return this.type_id ? this.$t(Readings.readingTypes.get(parseInt(this.type_id)).translationKey + '.html') : '(no type)'
		},
		isGeofencing () {
			return this.type_id === Readings.TYPE_GEOFENCING
		},
		isBiometric () {
			return this.type_id !== Readings.TYPE_GEOFENCING
		},
		title () {
			return this.isGeofencing ? this.$t('readings.general.zone_list') : this.$t('readings.general.alert_parameters')
		},
		addRouteName () {
			return this.isGeofencing ? 'WatchGeofencingZoneAdd' : 'WatchBiometricParametersAdd'
		},
		addRouteParams () {
			return this.isGeofencing ? { user_uid: this.user_uid, watch_id: this.watch_id } : { user_uid: this.user_uid, watch_id: this.watch_id, type_id: this.type_id }
		},
		emptyMessage () {
			return this.isGeofencing ? this.$t('readings.general.no_zones') : this.$t('readings.general.no_parameters')
		}
	},
	/*watch: {
		'$route' () {
			this.getParameters()
		}
	},*/
	methods: {
		getParameters () {
			this.parameters.loading = true
			this.parameters.data = []
			this.$api.parameters.getAll(this, this.user_uid, this.watch_id, this.type_id)
				.then(response => {
					this.$log.info(this.name, 'parameters.getAll OK', response)()
					this.parameters.data = response.body
					this.parameters.data.sort((a, b) => {
						if (a.urgency_type < b.urgency_type) return 1
						if (a.urgency_type > b.urgency_type) return -1
						return 0
					})
				}).catch(error => {
					this.$log.error(this.name, 'parameters.getAll ERROR', error)()
					this.parameters.error = error
				}).finally(() => {
					this.parameters.loading = false
				})
		},
		deleteParameter (id) {
			if (confirm('Delete?')) {
				this.loading.delete.add(id)
				this.$forceUpdate()
				this.$api.parameters.delete(this, this.user_uid, this.watch_id, this.type_id, id)
					.then(response => {
						this.$log.info(this.name, 'parameters.delete OK', response)()
						this.getParameters()
					}).catch(error => {
						this.$log.error(this.name, 'parameters.delete ERROR', error)()
						this.error = error
					}).finally(() => {
						this.loading.delete.delete(id)
					})
			}
		},
		getZones () {
			this.zones.loading = true
			this.zones.data = []
			this.$api.geofencing.getAll(this, this.user_uid, this.watch_id)
				.then(response => {
					this.$log.info(this.name, 'geofencing.getAll OK', response)()
					this.zones.data = Readings.processZones(response.body)
				}).catch(error => {
					this.$log.error(this.name, 'geofencing.getAll ERROR', error)()
					this.zones.error = error
				}).finally(() => {
					this.zones.loading = false
				})
		},
		deleteZone (id) {
			if (confirm('Delete?')) {
				this.loading.delete.add(id)
				this.$forceUpdate()
				this.$api.geofencing.delete(this, this.user_uid, this.watch_id, id)
					.then(response => {
						this.$log.info(this.name, 'geofencing.delete OK', response)()
						this.getZones()
					}).catch(error => {
						this.$log.error(this.name, 'geofencing.delete ERROR', error)()
						this.error = error
					}).finally(() => {
						this.loading.delete.delete(id)
					})
			}
		},
		onZoneClick (zone) {
			this.$emit('open-modal', zone)
		},
		getData () {
			switch (this.type_id) {
				case Readings.TYPE_GEOFENCING:
					this.getZones()
					break
				default:
					this.getParameters()
			}
		},
		openModal (params = {}) {
			this.modalBox.open = true
			this.modalBox.params = params
		},
		closeModal (params) {
			this.modalBox.open = false
			this.modalBox.params = {}

			if (params.reload) {
				this.getData()
			}
		},
		onRouteChanged () {
			// Next tick, otherwise type_id is not correct
			this.$nextTick(function () {
				this.getData()
			})
		}
	},
	created () {
		this.$parent.$on('biometric-details-route-changed', this.onRouteChanged)
	},
	beforeDestroy () {
		this.$parent.$off('biometric-details-route-changed', this.onRouteChanged)
	},
	mounted () {
		this.getData()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/widgets/ReadingsWidgetAlertParameters.vue